import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-541e3f8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help__page" }
const _hoisted_2 = { class: "help__page-inner" }
const _hoisted_3 = {
  key: 0,
  class: "help__text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "help__text"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help__text-title" }, "Что за картинки", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = {
  key: 2,
  class: "help__text"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help__text-title" }, "Механика 2048", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "help__actions" }
const _hoisted_17 = { class: "help__page-selectel-logo-block" }
const _hoisted_18 = { class: "help__actions-button-block" }
const _hoisted_19 = { class: "help_pagination-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_processor = _resolveComponent("tp-processor")!
  const _component_selectel = _resolveComponent("selectel")!
  const _component_tp_button = _resolveComponent("tp-button")!
  const _component_tp_box = _resolveComponent("tp-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_tp_box, null, {
        default: _withCtx(() => [
          (_ctx.page === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(" Эта игра — как 2048, но есть два отличия. Вы собираете не просто большие числа, а комплектующие сервера. И победить можно, только собрав все «запчасти» по порядку. "),
                _hoisted_4,
                _hoisted_5,
                _createTextVNode(" Есть восемь заданий и три уровня сложности, которые обозначены иконкой "),
                _createVNode(_component_tp_processor, {
                  class: "tp-level__processor",
                  isFull: true
                }),
                _hoisted_6,
                _hoisted_7,
                _createTextVNode(" Управление: на клавиатуре — стрелками, на сенсорных экранах — свайпами. ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.page === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" Комплектующие серверов развиваются и меняются: из перфокарт и селектронов получилось современное мощное железо. "),
                _hoisted_10,
                _createTextVNode(" Вы «собираете» CPU, GPU, RAM или HDD/SSD. Картинки на клетках показывают этапы развития этих комплектующих. Играя, вы последовательно формируете поколения устройства. "),
                _hoisted_11,
                _createTextVNode(" Комплектующие в задаче зависят от сервера. Например, для гейминга нужна технологичная видеокарта, а для 3D-моделирования — CPU и RAM. ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.page === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" Каждый ход в свободном месте на поле появляется элемент 1-го или 2-го уровня. "),
                _hoisted_14,
                _createTextVNode(" Нужно скидывать все элементы поля в одну из четырёх сторон. Сталкиваясь, два одинаковых элемента становятся одним. Уровень нового элемента повышается. "),
                _hoisted_15,
                _createTextVNode(" Игра заканчивается поражением, если невозможно совершить действие. ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_selectel)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_tp_button, {
                class: "close-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goHome()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Понятно")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.page === 1 ? 'help_pagination-button-active' : '', 'help_pagination-button']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(1)))
              }, " 1 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.page === 2 ? 'help_pagination-button-active' : '', 'help_pagination-button']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(2)))
              }, " 2 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.page === 3 ? 'help_pagination-button-active' : '', 'help_pagination-button']),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage(3)))
              }, " 3 ", 2)
            ])
          ]),
          _createElementVNode("div", {
            class: "help__blur",
            style: _normalizeStyle(`background: url(${require('@/assets/blue-blur.svg')}) no-repeat center`)
          }, null, 4)
        ]),
        _: 1
      })
    ])
  ]))
}